module.exports = __webpack_public_path__ + "static/media/instagram.b1c58ee1.svg";